<template>
    <button class="btn btn-danger" :class="btnClass" :disabled="poster.submitted" @click="triggerPost()">
        <span class="spinner-border spinner-border-sm"></span>
        <slot></slot>
    </button>
</template>

<script>
import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    props: {
        employee: {
            required: true
        },
        btnClass: {
            default: ''
        }
    },

    computed: {
        posterUrl () {
            return '/employees/' + this.employee.id + '/deleteAccount'
        }
    },

    methods: {
        posterSuccess (data) {
            bus.$emit(
                'notify',
                'Kontot har raderats'
            )
            this.$emit('refresh')
        },
        triggerPost() {
            if ( confirm("Vill du verkligen ta bort den anställdes konto? Det kan inte ångras.")){
                if ( confirm("Vänligen bekräfta igen.")){
                    this.posterPost()
                }
            }
        }

    }

}
</script>
